// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"baeac6ad","453":"53ea766f","455":"b259dca8"}[chunkId] + ".chunk.js";
};